import { FC } from 'react';
import { bigIntDecimalsDivision, bigIntFormat } from '../../../helpers/bignumber';
import { ICurrency } from '../../../types/currency';

export const CurrencyRow: FC<ICurrency> = ({
  currentSupply,
  initialSupply,
  decimals,
  creationHeight,
  description,
  accountRS,
  code,
}) => {
  const getDivision = (num: string) =>
    bigIntFormat(bigIntDecimalsDivision(num, decimals as number));

  const supply = getDivision(currentSupply);
  const initial = getDivision(initialSupply);

  return (
    <tr>
      <td>{`${initial} ${code}`}</td>
      <td>{`${supply} ${code}`}</td>
      <td>{creationHeight}</td>
      <td>{description}</td>
      <td>{accountRS}</td>
      <td>{code}</td>
    </tr>
  );
};
